export var ProjectStorageLocation;
(function (ProjectStorageLocation) {
    ProjectStorageLocation["EU"] = "eu";
    ProjectStorageLocation["US"] = "us";
    ProjectStorageLocation["AWS_EU_WEST_1"] = "eu-west-1";
    ProjectStorageLocation["AWS_US_EAST_1"] = "us-east-1";
    ProjectStorageLocation["AZURE_EU_NORTH"] = "northeurope";
    ProjectStorageLocation["AZURE_US_EAST_2"] = "eastus2";
})(ProjectStorageLocation || (ProjectStorageLocation = {}));
export var ProjectStorageCloud;
(function (ProjectStorageCloud) {
    ProjectStorageCloud["AZURE"] = "azure";
    ProjectStorageCloud["AWS"] = "aws";
})(ProjectStorageCloud || (ProjectStorageCloud = {}));
export const UnstableStorageLocations = [ProjectStorageLocation.AZURE_US_EAST_2, ProjectStorageLocation.AZURE_EU_NORTH];
export function resolveProjectStorageLocation(storageLocation) {
    // handle legacy storage location format
    // TODO update legacy storage location format depending on migration
    switch (storageLocation) {
        case ProjectStorageLocation.EU:
            return ProjectStorageLocation.AWS_EU_WEST_1;
        case ProjectStorageLocation.US:
            return ProjectStorageLocation.AWS_US_EAST_1;
        default:
            return storageLocation;
    }
}
export function resolveProjectStorageCloud(storageLocation) {
    switch (storageLocation) {
        case ProjectStorageLocation.AWS_EU_WEST_1:
        case ProjectStorageLocation.AWS_US_EAST_1:
            return ProjectStorageCloud.AWS;
        case ProjectStorageLocation.AZURE_EU_NORTH:
        case ProjectStorageLocation.AZURE_US_EAST_2:
            return ProjectStorageCloud.AZURE;
        default:
            return undefined;
    }
}
// if you add new values to ProjectStorageLocation you also need to update this method too.
export function getCTLocationFromCSLocation(storageLocation) {
    switch (storageLocation) {
        case ProjectStorageLocation.EU:
        case ProjectStorageLocation.AWS_EU_WEST_1:
        case ProjectStorageLocation.AZURE_EU_NORTH:
            return 'EU';
        case ProjectStorageLocation.US:
        case ProjectStorageLocation.AWS_US_EAST_1:
        case ProjectStorageLocation.AZURE_US_EAST_2:
            return 'US';
        default:
            return 'NOT DEFINED';
    }
}
//# sourceMappingURL=project.storage.location.js.map